<script setup lang="ts">
import type { ContentNode } from "#layers/books/types";

defineProps<{
  children: ContentNode[];
  title?: string;
}>();
</script>

<template>
  <div
    v-if="children.length > 0"
    class="mt-8 border-t border-gray-200 dark:border-gray-700 pt-8"
  >
    <h2
      v-if="title"
      class="text-lg font-semibold text-gray-900 dark:text-white mb-4"
    >
      {{ title }}
    </h2>
    <div class="grid gap-3">
      <NuxtLink
        v-for="child in children"
        :key="child.id"
        :to="child.path"
        class="flex items-center gap-3 p-4 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary-300 dark:hover:border-primary-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
      >
        <UIcon
          :name="
            child.type === 'container'
              ? 'i-heroicons-folder'
              : 'i-heroicons-document-text'
          "
          class="w-5 h-5 flex-shrink-0"
          :class="
            child.type === 'container' ? 'text-amber-500' : 'text-gray-400'
          "
        />
        <span class="text-gray-900 dark:text-white font-medium">{{
          child.title
        }}</span>
        <UIcon
          name="i-heroicons-chevron-right"
          class="w-4 h-4 ml-auto text-gray-400"
        />
      </NuxtLink>
    </div>
  </div>
</template>
